import { useState } from 'react'

/**
 * Custom hook to detect dark mode
 * Returns 'dark' when in dark mode, undefined otherwise
 *
 * Detection strategy:
 * - Check for vd-theme--dark class on body element once on mount
 * - Theme is static for component's lifetime (modal lifespan is typically < 1 minute)
 * - Standard workflow: toggle theme before opening modal
 */
export const useTheme = (): 'dark' | undefined => {
  const [theme] = useState<'dark' | undefined>(() =>
    document.body.classList.contains('vd-theme--dark') ? 'dark' : undefined
  )

  return theme
}
